import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";

import TableContainer from "../../containers/Tables/TableContainer";
import CreatePatientModal from "../../containers/Modals/CreatePatientModal";

import { tableHeaders } from "../../hooks/constants";
import { usePatientNavigation } from "../../hooks/useDetailNavigation";

import { checkAuthenticated } from "../../actions/auth";
import { load_patient_list } from "../../actions/clinic_content";
import { ButtonGroup } from "react-bootstrap";
import ImportPatientsModal from "../../containers/Modals/ImportPatientsModal";

const PatientsPage = () => {
  const dispatch = useDispatch();
  const [modalsInfo, setModalInfo] = useState({
    addPatientShow: false,
    importPatientShow: false,
  });
  const [patientList, setPatientList] = useState([]);
  const [urlNext, setUrlNext] = useState("");

  const [textSearch, setTextSearch] = useState("");
  const { goToPatientDetail } = usePatientNavigation();

  const handleSetNextPage = (urlNext) => {
    try {
      const url = new URL(urlNext);
      const endpoint = url.pathname + url.search;
      setUrlNext(`${process.env.REACT_APP_API_URL}${endpoint}`);
    } catch (error) {
      console.log(error);
      setUrlNext("");
    }
  };

  const fetchPatientList = async () => {
    const params = {
      textSearch: textSearch,
    };

    const data = await load_patient_list(params);
    if (data) {
      setPatientList(data.results);
      handleSetNextPage(data.next);
    }
  };

  const handleNextPage = async () => {
    const data = await load_patient_list(null, urlNext);
    if (data) {
      setPatientList([...patientList, ...data.results]);
      handleSetNextPage(data.next);
    }
  };

  const handleSearch = () => {
    fetchPatientList();
  };

  const tableConfig = {
    headers: tableHeaders.patientsTable,
    checkable: false,
    urlNext: urlNext,
    handleNextPage: handleNextPage,
    detailFunction: goToPatientDetail,
    listData: patientList,
  };

  useEffect(() => {
    dispatch(checkAuthenticated());

    fetchPatientList();
  }, []);
  return (
    <div className="content">
      <div className="d-flex justify-content-between align-items-center page-title">
        <h1>Pacientes</h1>
        <div className="d-flex gap-2 mx-2">
          <ButtonGroup>
            <Button
              className="fw-bolder"
              variant="outline-primary"
              onClick={() =>
                setModalInfo({ ...modalsInfo, importPatientShow: true })
              }
            >
              Importar Lista
            </Button>
            {/* <Button className="fw-bolder" variant="outline-primary">
              Exportar Lista
            </Button> */}
          </ButtonGroup>
          <Button
            variant="primary"
            onClick={() =>
              setModalInfo({ ...modalsInfo, addPatientShow: true })
            }
          >
            Agregar Paciente
          </Button>
        </div>
      </div>
      <div className="input-group mb-3">
        {/* <Button variant="outline-secondary">Filtros y Ordenamiento</Button> */}

        <input
          type="text"
          className="form-control"
          placeholder="Buscar por Apellidos, Rut o Nombre"
          onChange={(e) => setTextSearch(e.target.value)}
        />
        <Button
          className="d-flex gap-2"
          variant="outline-secondary"
          onClick={handleSearch}
        >
          <i className="bi bi-search"></i>
          Buscar / Refrescar
        </Button>
      </div>
      <TableContainer tableConfig={tableConfig} />
      <CreatePatientModal
        show={modalsInfo.addPatientShow}
        onHide={() => setModalInfo({ ...modalsInfo, addPatientShow: false })}
      />
      <ImportPatientsModal
        show={modalsInfo.importPatientShow}
        onHide={() => setModalInfo({ ...modalsInfo, importPatientShow: false })}
      />
    </div>
  );
};

export default PatientsPage;
